import { Box, Typography } from '@mui/material';

interface IProps {
    subText1?: string;
    subText2?: string;
    subText3?: React.ReactNode;
    hideHeader?: boolean;
}

export const NoDataScreen = (props: IProps) => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "450px",
            }}
        >
            <img
                src={`${process.env.PUBLIC_URL}/img/Empty_Box.svg`}
                alt="Empty Box"
                style={{ height: "300px", width: "300px" }}
            />
            {!props.hideHeader && <Typography variant="h4">
                It seems a bit empty in here
            </Typography>
            }
            {props.subText1 &&
                <Typography variant="body2" color="secondary">
                    {props.subText1}
                </Typography>
            }
            {props.subText2 &&
                <Typography variant="body2" color="secondary">
                    {props.subText2}
                </Typography>
            }
            {props.subText3}
        </Box>
    );
}
